export default {
  'navigation.drawer_user_info.drawer_user_detail.team_clipboard_text':
    'Copy Team ID',
  'navigation.drawer_user_info.drawer_user_detail.company_clipboard_text':
    'Copy Company ID'
}
